export const GOOGLE_ANALYTICS_EVENTS = {
    // GOOGLE TAG MANAGER EVENTS
    GT_REG_PHONE_DONE: 'reg-phone-done',
    GT_REG_SUCCESS: 'reg-success',
    GT_LOGIN_SUCCESS: 'login-success',
    GT_SEND_MONEY_FROM_AMOUNT: 'send-money-from-amount',
    GT_NEW_TRANSFER_START: 'new-transfer-start',
    GT_TRANSFER_REPEAT_START: 'transfer-repeat-start',
    GT_OUT_REQUEST_SEND: 'out-request-send',
    GT_SEND_SUCCESS: 'send-success',
    // GA4 EVENTS
    GA4_SIGN_UP: 'sign_up',
    GA4_SEND_FIRST_SUCCESS: 'send_first_success',
    GA4_PAGE_TRANSLATED: 'page_translated',
    // Libre
    GT_LIBRE_LANDING_PAGE_SHOWN: 'Libre Landing Page Shown',
    GT_LP_RECEIVE_MONEY_CLICKED: 'LP Receive Money Clicked',
    GT_LP_FAQ_CLICKED: 'LP FAQ Clicked',
} as const;

export type GoogleAnalyticsEventKey = keyof typeof GOOGLE_ANALYTICS_EVENTS;
export type GoogleAnalyticsEventValue = (typeof GOOGLE_ANALYTICS_EVENTS)[GoogleAnalyticsEventKey];

export const {
    GT_REG_PHONE_DONE,
    GT_REG_SUCCESS,
    GT_LOGIN_SUCCESS,
    GT_SEND_MONEY_FROM_AMOUNT,
    GT_NEW_TRANSFER_START,
    GT_TRANSFER_REPEAT_START,
    GT_OUT_REQUEST_SEND,
    GT_SEND_SUCCESS,
    GA4_SIGN_UP,
    GA4_SEND_FIRST_SUCCESS,
    GA4_PAGE_TRANSLATED,
    GT_LIBRE_LANDING_PAGE_SHOWN,
    GT_LP_RECEIVE_MONEY_CLICKED,
    GT_LP_FAQ_CLICKED,
} = GOOGLE_ANALYTICS_EVENTS;
